import './listingdirective.css'
import Outlined from '../div/Outlined'
import {Link} from 'react-router-dom'

const ListingDirective = () => {
  return <div className='directives'>
      <h1>List you rentals for sale or renting </h1>
  <Outlined/>
      <div className='procedure--listing'>
          <h5>How can you list you property with use?</h5>
          <p>1. Identify the property you want to be listed.</p>
          <p>2. Reach our property listing page here exqui properties</p>
          <p>3. Write the property or house description.</p>
          <p>4. Upload some few images of the property there.</p>
          <p>5. State clearly the period you want your property to be listed.</p>
          <p>6. Pay the property listing cost using the number shared and send us the payment code</p>
          <p>7. <b>NB:</b> Your property will be listed out from our list table is the listing payment is not paid </p>
      </div>
      <div className='time'>
          <h2>Where will your property be listed?</h2>
          <p>Your property will be listed in our property listing web page</p>
        <Link to='/others'><button className='time--btn'>See listed properties</button></Link>
      </div>
  </div>;
};

export default ListingDirective;
